export function debounce<T extends (...args: any[]) => any>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeoutId: number;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export const withOfflineSupport = <T, P extends unknown[]>(
  onlineFunction: (...args: P) => Promise<T>,
  offlineFunction: (...args: P) => Promise<T>
) => {
  return async (...args: P): Promise<T> => {
    try {
      if (navigator.onLine) {
        return await onlineFunction(...args);
      } else {
        console.log("Offline mode: using cached data");
        return await offlineFunction(...args);
      }
    } catch (error: unknown) {
      console.error("Error in online operation, maybe falling back:", error);

      const isNetworkError =
        !navigator.onLine || 
        (error && typeof error === 'object' && 'status' in error && (error as { status: number }).status === 0) || 
        (error && typeof error === 'object' && 'message' in error && (error as { message: string }).message === "Network Error");

      if (isNetworkError) {
        return await offlineFunction(...args);
      }

      throw error;
    }
  };
};

export const convertStringHumanReadable = (text: string) => {
  if (!text) return '';

  const normalizedText = text.trim().toLowerCase().replace(/[\s-]+/g, "_");
  if (normalizedText === "pre_challenge") {
    return "Dilutions";
  }

  return text
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}
